import React from 'react';

import { useSidePanels } from './hooks/use-side-panels';
import { SidePanelManagerContextProvider } from './side-panel-manager-context/provider';
import { Panels } from './panels';

type Props = {
    isMobile: boolean;
};

export const Modals: React.FC<Props> = ({ isMobile }) => {
    const { isSidePanelOpen, sidePanelParams, openPreviousSidePanel } = useSidePanels();

    if (!sidePanelParams) {
        return null;
    }

    return (
        <SidePanelManagerContextProvider
            open={isSidePanelOpen}
            platform={isMobile ? 'mobile' : 'desktop'}
        >
            <Panels
                sidePanelParams={sidePanelParams}
                openPreviousSidePanel={openPreviousSidePanel}
            />
        </SidePanelManagerContextProvider>
    );
};
